import root from 'window-or-global';

import UrlBuilder from './UrlBuilder';
import FetchHelper from '../FetchHelper';
import formurlencoded from 'form-urlencoded';
import { getParamFromUrl } from '../index';
import { STORE_RESPONSE_URL } from '../../constants/url';
import store from '../../store';
import JobsContext from '../../utils/Context';
import { updateJobSearchReducer } from '../../actions/JobSearchActions';
import {
  filterMountedAction,
  updateNorthEastCityFilter,
  toggleNorthEasthCityFilter
} from "../../actions/SnbContainerActions";
import { BASE_URL, SEARCH_API } from '../../constants';


export const createSearchUrl = (selectedFilters) => {
	let urlBuilder = new UrlBuilder();
	let url = urlBuilder.getJobsSnbUrl(selectedFilters);
	return url;
};


/**
 * Get Search Results from url and get parameters
 */
export const getSearchResultsOld  = (url,searchParams,params) => {
	let fetchHelper = new FetchHelper();

	let defaultParams = {
		fromPwa: 1,
		aj: 1,
		...params
	};

	let paramString = formurlencoded(defaultParams);
	//Using older api for search

	if (searchParams && searchParams !== '') {
		paramString = searchParams+'&'+paramString;
	}
	else {
		paramString = '?'+paramString;
	}
	let apiParams = {
		url: root.location.protocol+'//www.quikr.com'+url+paramString
	};

	return fetchHelper.request('get', apiParams);
};

export const getSearchResultsPromise = (searchParams, directApplyAdId=null, ssr=false, dispatch=null, cookies=null) => {
  const dispatchPromises = [];
  if (!dispatch) {
    dispatch = store.dispatch;
  }

  return getSearchResults(searchParams, directApplyAdId, ssr, dispatch, cookies).then((response) => {
    const data = (response.data) ? response.data : {};
    const responseJson = data.json;
    const jobList = responseJson.searchResponse.jobList ? responseJson.searchResponse.jobList : [];
    const pageCount = responseJson.pwaOptions.pageCount;
    const searchCount = responseJson.searchResponse.searchCount;
    const searchComplete = (((pageCount * (searchParams.page - 1)) + jobList.length) >= searchCount);
    const showNorthEastCityFilter = responseJson.showNorthEastCityFilter;
    const isMyNorthEastCityFilter = responseJson.isMyNorthEastCityFilter;

    const companyList = responseJson.searchResponse.companyList;
    if (companyList) {
      let filters = {
        data: {
          json: {
            companies: companyList
          }
        }
      };
      dispatchPromises.push(dispatch(filterMountedAction(filters)));
    }

    let updatedJobs = JobsContext.filterJobs(jobList, false);

    let jobSearchState = {
      jobs: updatedJobs,
      page: searchParams.page + 1,
      pageCount: pageCount,
      searchCount: searchCount,
      searchComplete: searchComplete
    };
    
    if (responseJson.pwaOptions) {
      jobSearchState = Object.assign(jobSearchState, {
        dfpRepetitionIndex: responseJson.pwaOptions.dfpRepetitionIndex,
        dfpOptions: responseJson.pwaOptions.dfpOtions,
        flyingCarpetPosition: responseJson.pwaOptions.flyingCarpetPosition
      });
    }

    dispatchPromises.push(dispatch(updateNorthEastCityFilter({ showNorthEastCityFilter })));
    dispatchPromises.push(dispatch(toggleNorthEasthCityFilter({ isMyNorthEastCityFilter })));
    dispatchPromises.push(dispatch(updateJobSearchReducer(jobSearchState)));
    return dispatchPromises;
  });
};

export const getSearchResults = (searchParams, directApplyAdId, ssr, dispatch, cookies) => {
  let url;
  if (directApplyAdId) {
    searchParams.directApplyAdId = directApplyAdId;
  }
  let fetchHelper = new FetchHelper();

  if (ssr) {
    url = __JOBS_BAAHUBALI_PREFIX__ + BASE_URL + SEARCH_API;
  } else {
    url = BASE_URL + SEARCH_API;
  }

  let apiParams = {
    url: url,
    data: formurlencoded(searchParams),
    includeCredentials: true
  };

  if (cookies) {
    apiParams.cookies = cookies;
  }

  return fetchHelper.request('POST', apiParams);
};

export function setPageToLoadFromUrl(defaultContext) {
  defaultContext = handleAMPActions(defaultContext);

  return defaultContext;
}

export function handleAMPActions(defaultContext) {
	let page = getParamFromUrl("page");
	if(null !== page){
		defaultContext.page = parseInt(page);
	}

	let action = getParamFromUrl('ac');
	let adId = getParamFromUrl('adId');

	defaultContext.hideJobs = (('apply' === action) && (null !== adId));
	return defaultContext;
}

export function getTrendingJobsFromApi(params) {
	let fetchHelper = new FetchHelper();
	let apiParams = {
		params: params,
		url: `/jobs/trending`
	};
	return fetchHelper.request('GET', apiParams);
}
/**
 * @author Alabhya Vaibhav
 * Utility functions for getting the mapped subroles, keywords and present links data for similar jobs/internal links. 
 */
export function getFooterLinksDataFromApi(params) {
	let fetchHelper = new FetchHelper();

  if (null != params['jobType']) {
    params['jobType'] = params['jobType'].toLowerCase().split(' ').join('-');
  }

	let apiParams = {
		params: params,
		url: `/jobs/footerlink`
	};
	return fetchHelper.request('GET', apiParams);
}

/**
 * Utility function to store candidate response from emails
 */
export function storeCandidateResponseViaAjax(profileId,recruiterId) {
	let data = 'profileId='+profileId+'&recruiterId=' + recruiterId;
	let fetchHelper = new FetchHelper();
	let apiParams = {
		data : data,
		url: `${root.location.protocol}//www.quikr.com/jobs`+STORE_RESPONSE_URL
	}
	return fetchHelper.request('POST', apiParams);
}

/**
 * @author Alabhya Vaibhav
 * Utility functions for sending  the user current location for recruiter tracking. 
 */
export function sendUserLocationtoDB(params) {
	let fetchHelper = new FetchHelper();
	let apiParams = {
		params: params,
		url: `/jobs/hire/userLocation`
	};
	return fetchHelper.request('POST', apiParams);
}

export function fetchFaqs(cityName, roleId) {
  let fetchHelper = new FetchHelper();
  let params = {
    url: '/jobs/roleFaqs',
    data: `&location=${cityName}&roleId=${roleId}`,
  };
  return fetchHelper.request('POST', params);
}


// WEBPACK FOOTER //
// ../q-jobs/src/utils/Search/index.js